import './polyfills';
import $ from 'jquery';
import Popper from 'popper.js';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { RouteTable } from './components/route-table/RouteTable';
import * as serviceWorker from './serviceWorker';
import { getApplicationStore } from './store/configure-store';
import { configureStore } from './store/configure-store';
import { configureEnvironment } from './utils/app-settings';
import { AuthenticationManager } from './utils/auth-manager';
import { history } from './utils/history';
import { initGoogleMaps } from './utils/mapping-provider';

const win = window as any;
win.$ = $;
win.jQuery = $;
win.Popper = Popper;

// Before we do anything, we need to read in a JSON
// file that configures our app.
const envProm = configureEnvironment();
envProm.then(() => {

    // initGoogleMaps();
    configureStore();
    
    AuthenticationManager.initialize();
    AuthenticationManager.run(() => {
    
        function renderApp() {
            ReactDOM.render(
                <Provider store={getApplicationStore()}>
                    <Router history={history}>
                        <RouteTable />
                    </Router>
                </Provider>,
                document.getElementById('root')
            );
        }

        // registerServiceWorker();
        // If you want your app to work offline and load faster, you can change
        // unregister() to register() below. Note this comes with some pitfalls.
        // Learn more about service workers: http://bit.ly/CRA-PWA
        serviceWorker.unregister();

        renderApp();
    
    });

})
.catch((err) => {        
    window.alert("[FATAL] Unable to read environment config.  App will not be able to function, please contact support.");
});